import { jsx as _jsx } from "react/jsx-runtime";
import { Sync } from "@air/next-icons";
export const FileStatusIconProgressing = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        "aria-hidden": true,
        className: "mr-3 flex size-10 animate-spin items-center justify-center rounded-full bg-indigo-1 motion-reduce:animate-none",
        children: /*#__PURE__*/ _jsx(Sync, {
            className: "size-6 fill-indigo-9"
        })
    });
};
